export const isConversionTransition = (result: unknown): boolean => {
  if (!result || typeof result !== 'object') {
    return false;
  }
  const r = result as { stageChanged?: unknown; newStageName?: unknown };
  if (r.stageChanged !== true) {
    return false;
  }
  return r.newStageName === 'in_progress' || r.newStageName === 'invoice';
};
